var jQuery=$=require('jquery');
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
            		id: '',
		            param:'',
		            url:this.baseApiPath,
		            user:localStorage['username'],
		             activities: [],
                     isconfirm:false
             }
        },
        //计算属性
        computed: {
        	
        },
        ready:function(){

             this.param = this.$route.params.id;
            if (this.param) {
                this.method = 'amenserv_update_activity';
                this.id = this.param;
                var jqPromise = $.post(this.url, {
                    method: 'amenserv_activity',
                    token: localStorage['token'],
                    hotel: this.param
                });
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    that.id = value.data&&value.data.id || that.param;
                    that.activities = value.data || [{
                        name: '',
                        hotel:'',
                        pic:'',
                        text:'',
                    }]
                    return value;
                })

            }
        },
         attached:function(){
            var that=this;
            $('.container-fluid').on('change','input',function(){
                that.isconfirm=true;
            });
            $('.container-fluid').on('change','textarea',function(){
                that.isconfirm=true;
            });
            
        },
        methods: {
            uploadhandle:function(e){
                var that=this;
                 var fileList = e.target.files;
                //console.log(files)
                var reader=new FileReader();
              //  console.log(that.num)
                if(fileList[0]&& fileList[0].type&& fileList[0].type.match('image.*')){
                    reader.readAsDataURL(fileList[0]);
                  }
                reader.onload = (function(file){
                    return function(e){
                      //  console.log(that.num)
                       var dataURL = reader.result;
                         var data = {
                                method: 'picture_upload',
                                token: localStorage['token'],
                                file: dataURL,
                                name:fileList[0].name
                            }
                            var jqPromise = $.post(that.baseApiPath, data);
                            var realPromise = Promise.resolve(jqPromise);
                            realPromise.then(function(value){
                                var value= JSON.parse(value);
                                 that.activities[that.num].pic=value.data.file
                            }) 
                    }
                // console.log(reader.result)
                // console.log(dataURL)

                //  var output = document.getElementById('output');
                // for(var item in input.files){

                  // }
                 //  var str = "<img data-id='123145' src='"+dataURL+"'>";
                 //  $('#output').append(str);
                 // console.log(str)
                 //  output.src = dataURL;
                })(fileList[0])
            },
           uploadpic :function(num){
                this.num=num;
                // console.log(num)
                $('.deshandle:eq('+num+')').trigger('click');
            },
        	addSpeicalService: function() {
                if (this.activities.length <= 5) {
                    var that = this;
                    var p1 = new Promise(function(resolve, reject) {
                        resolve('success')
                    })
                    p1.then(function(value) {
                        that.activities.push({
                        name: '',
                        hotel:'',
                        pic:'',
                        text:'',
                    });
                        return value;
                    })
                    // .then(function(value) {
                    //     $('.designernote').summernote({
                    //         height: 180
                    //     });
                    // })

                } else {
                    alert('最多只能添加6个活动')
                }
            },
            removeactivity:function(n){
                this.activities.splice(n,1)
            },
            serviceSubmit: function() {
                //console.log(this)
                var data = {
                    hotel: this.id||this.param,
                    method: this.method,
                    token: localStorage['token'],
                    activities:this.activities
                };
               // console.log(data)
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    if (value.code == 0) {
                        that.isconfirm=false;
                        that.$route.router.go({name:'list'})
                    } else {
                        alert(value.message)
                    }
                })
            }

           },
        route:{
            activate:function(transtition){
            	window.scrollTo(0,0);
                transtition.next()
            },
             canDeactivate:function(transition){
                if(this.isconfirm){
                    if(confirm('还未保存，确定退出？')){
                        transition.next()
                    }else{
                        transition.abort()
                    }
                }else{
                    transition.next()
                }
                
            },
            data: function() {
             this.param = this.$route.params.id;
             this.$dispatch('pageinfo','酒店活动');
            if (this.param) {
                this.method = 'amenserv_update_activity';
                this.id = this.param;
                var jqPromise = $.post(this.url, {
                    method: 'amenserv_activity',
                    token: localStorage['token'],
                    hotel: this.param
                });
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    that.id = value.data&&value.data.id || that.param;
                    that.activities = value.data || [{
                        name: '',
                        hotel:'',
                        pic:'',
                        text:'',
                    }]
                    return value;
                })

            }
        },
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/activity.vue
// module id = 104
// module chunks = 0